import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";

export default class extends Controller {
  static targets = ["file", "signedId", "progress"];
  static values = { url: String };

  connect() {
    this.element.dataset.state = "uploading";

    new DirectUpload(this.fileTarget.files[0], this.urlValue, this).create(
      (error, blob) => {
        if (error) {
          this.element.dataset.state = "failed";
        } else {
          this.signedIdTarget.value = blob.signed_id;
          this.element.dataset.state = "uploaded";
        }
        this.dispatch("finished");
      },
    );
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", ({ loaded, total }) => {
      this.progressTarget.style.width = `${(loaded / total) * 100}%`;
    });
  }
}
